import { render, staticRenderFns } from "./Safety4.vue?vue&type=template&id=15ef5c1a&scoped=true"
import script from "./Safety4.vue?vue&type=script&lang=js"
export * from "./Safety4.vue?vue&type=script&lang=js"
import style0 from "./Safety4.vue?vue&type=style&index=0&id=15ef5c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef5c1a",
  null
  
)

export default component.exports